import Header from "../components/Header";
import Table from 'react-bootstrap/Table';

import Image from "react-bootstrap/Image";
import { useState, useEffect, Fragment } from "react";

import { ObjectStatus } from "../components/ObjectStatus";
import { postDataHelper, postDataWithHeaderHelper } from "../requests/PostRequests";

import NavBar from "../components/NavBar";

import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";

import { RiVipCrownLine } from "react-icons/ri";

import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Doughnut, Line } from 'react-chartjs-2';
import Stack from "react-bootstrap/esm/Stack";
import Button from "react-bootstrap/esm/Button";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const CourseStatistics = ({ onTriggerMessage }) => {

  const [courseLikes, setCourseLikes] = useState([]);

  // Dictionary of courses with courseId as the key
  // courseId : { id: "", course_code: "", image_url: "", en: {}, zh: {}}
  const [courses, setCourses] = useState({});

  /**
   * This function will go through all the languages and load into `courses`
   * @param {[]} dictionary of courses
   * @param {[]} languages 
   */
  async function getCourses(languages, courses) {
    const language = languages.pop();

    const onSuccess = (data) => {
      let outgoingCourses = courses;
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        const courseId = parseInt(rows[i].id);
        if (!(courseId in outgoingCourses)) {
          // Process the tags once
          let tags = [];
          const tagsLength = rows[i].tags.length;
          for (let j = 0; j < tagsLength; j++) {
            tags.push({
              tag: rows[i].tags[j].tag,
              index: rows[i].tags[j].index,
            });
          }
          // If does not exist, we create them
          outgoingCourses[courseId] = {
            id: courseId,
            course_code: rows[i].course_code,
            image_url: rows[i].image_url,
            tags: tags,
            status: ObjectStatus.Sync,
            likes: rows[i].likes,
            [language]: {
              name: rows[i].name,
              description: rows[i].description,
              status: ObjectStatus.Sync,
            }
          };
        } else {
          // if exist, we just add to the language
          outgoingCourses[courseId][language] = {
            name: rows[i].name,
            description: rows[i].description,
            status: ObjectStatus.Sync,
          }
        }
      }

      if (languages.length == 0) {
        setCourses(outgoingCourses);
      } else {
        // Remove one language and continue
        getCourses(languages, outgoingCourses);
      }
    };

    await postDataHelper("/v1/courses",
      { language: language },
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  }

  /**
   * This function will get all the likes we have in the database
   */
  async function getLikes() {
    const onSuccess = (data) => {
      let newLikes = [];
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        newLikes.push({
          course_id: parseInt(rows[i].course_id),
          created_at: rows[i].created_at,
          user_id: rows[i].user_id,
        });
      }

      setCourseLikes(newLikes);
    };

    await postDataWithHeaderHelper("/v1/courses/likes",
      {},
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  }

  useEffect(() => {
    async function fetchData() {
      await getCourses(["en", "zh"], {});
      await getLikes();
    }

    fetchData();
  }, []);

  function ShowTop10CourseLiked() {
    const arrayOfCourses = Object.values(courses).map((item, _) => item);
    const sortedByLikes = arrayOfCourses.sort((a, b) => b.likes - a.likes);
    const top10Likes = sortedByLikes.slice(0, 10);

    return (
      <Stack gap={2}>
        {top10Likes.map(function (item, index) {
          const name = "en" in item ? item.en.name : item.zh.name;
          return (
            <Button
              key={`course_like_chart_${index}`}
              className="btn-custom-secondary"
              style={{ padding: "10px", margin: "10px 10px 0 10px" }}
              variant="info">
              {index + 1}. {name} - {item.likes} Likes
              {index == 0
                ? <RiVipCrownLine style={{ margin: "10px" }} />
                : <Fragment />}
            </Button>
          );
        })}
      </Stack>
    );
  }

  function OverallCourseLikedChart() {
    const arrayOfCourses = Object.values(courses).map((item, _) => item);
    const sortedByLikes = arrayOfCourses.sort((a, b) => b.likes - a.likes);
    const top4Likes = sortedByLikes.slice(0, 4);
    const remainingLikes = sortedByLikes.slice(4).reduce((total, item) => total += item.likes, 0);

    const labels = [...top4Likes.map((item, _) => item.course_code), "Others"];
    const dataSet = [...top4Likes.map((item, _) => item.likes), remainingLikes];

    const data = {
      labels: labels,
      datasets: [
        {
          label: '# of Likes',
          data: dataSet,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };

    // References:
    // - https://www.chartjs.org/docs/latest/configuration/
    const options = {
      maintainAspectRatio: false,
      layout: {
        padding: 40
      },
      plugins: {
        legend: {
          title: {
            display: true,
            text: "Top 5 Courses Liked",
            padding: {
              top: 25,
            }
          },
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            padding: 20,
          },
        }
      }
    };

    return (
      <Doughnut data={data} options={options} />
    );
  }

  function convertDateToString(timestamp) {
    let date = new Date(timestamp);
    return `${(date.getMonth() + 1)}/${date.getDate()}/${date.getFullYear()}`;
  }

  function LikeOverTimeChart() {

    const dates = courseLikes.sort((a, b) => new Date(a.created_at) > new Date(b.created_at));

    var dictOfDates = {};

    // We want to populate dictOfDates with all the dates since the earliest like
    // to prevent missing dates if there were no like on a particular day.
    if(dates.length > 0) {
      var startDate = new Date(dates[0].created_at);
      const today = new Date();

      while (startDate <= today) {
        const dateStr = convertDateToString(startDate);
        dictOfDates[dateStr] = 0;
        startDate.setDate(startDate.getDate() + 1);
      }
    }

    const likesByDate = courseLikes.reduce(
      function (dict, element) {
        const dateStr = convertDateToString(element.created_at);
        if (dict[dateStr] === undefined) {
          dict[dateStr] = 1;
        } else {
          dict[dateStr] += 1
        }

        return dict;
      },
      dictOfDates);

    const labels = Object.keys(likesByDate).map((item) => convertDateToString(item));
    const dataSet = Object.values(likesByDate).map((item) => item);

    const options = {
      maintainAspectRatio: false,
      scales: {
        y: {
          min: 0,
        }
      }
    }

    const data = {
      labels,
      datasets: [
        {
          label: 'Number of likes by date',
          data: dataSet,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
      ],
    };

    return (
      <Line data={data} options={options} />
    );
  }

  function LanguageRows({ id }) {
    const course = courses[id];
    const courseZh = course["zh"];
    const courseEn = course["en"];
    return (
      <Fragment key={`${id}_language_row_fragment`}>
        <tr key={`${id}_language_header_row`}>
          <th colSpan={8}>Course Translations</th>
        </tr>
        {
          courseEn != undefined ? <Fragment key={`en_${courseEn.id}_language_item_row_fragment`}>
            <tr key={`en_${courseEn.id}_language_row`}>
              <td colSpan={4}>{courseEn.name}</td>
              <td colSpan={4}>{courseEn.description}</td>
            </tr>
          </Fragment>
            : <Fragment></Fragment>
        }
        {
          courseZh != undefined ? <Fragment key={`zh_${courseZh.id}_language_item_row_fragment`}>
            <tr key={`zh_${courseZh.id}_language_row`}>
              <td colSpan={4}>{courseZh.name}</td>
              <td colSpan={4}>{courseZh.description}</td>
            </tr>
          </Fragment>
            : <Fragment></Fragment>
        }
      </Fragment>
    );
  }

  function CoursesTable() {
    return (
      <Table responsive="sm">
        <tbody>
          <tr key="course_header_row">
            <th>ID</th>
            <th>Course Code</th>
            <th colSpan={2}>Name</th>
            <th>Image</th>
            <th colSpan={2}>Tags</th>
            <th>Likes</th>
          </tr>
          <tr key="course_header_blank_row"><td colSpan={8}></td></tr>
          {Object.values(courses).map(function (item, index) {
            const name = "en" in item ? item.en.name : item.zh.name;
            return (
              <Fragment key={`${item.id}_${index}_main_fragment`}>
                {item.status !== ObjectStatus.Deleted
                  ? <Fragment key={`${item.id}_fragment`}>
                    <tr key={`${item.id}_course_title_row`}><th colSpan={8}>{name}</th></tr>
                    <tr key={`${item.id}_guide_row`}>
                      <td>{item.id}</td>
                      <td>{item.course_code}</td>
                      <td colSpan={2}>{name}</td>
                      <td><Image src={item.image_url} style={{ height: "5vw", width: "5vw" }} rounded /></td>
                      <td colSpan={2}>{item.tags.length}</td>
                      <td>{item.likes}</td>
                      {/* <td><Button variant="primary" onClick={() => onEditUserGuide(item.id)}>Edit</Button></td>
                      <td><Button variant="danger" onClick={() => onDeleteUserGuide(item.id)}>Delete</Button></td> */}
                    </tr>
                    <tr key={`${item.id}_course_blank_row`}><td colSpan={8}></td></tr>
                  </Fragment>
                  : <Fragment key={`${item.id}_fragment_deleted`}></Fragment>
                }
              </Fragment>
            );
          })}
        </tbody >
      </Table >
    );
  }

  return (
    <Fragment>
      <NavBar />
      <div className="container-content-fixed">
        <div className="courses-hdr-grp">
          <Header title="Course Statistics" />
        </div>
        <CardGroup className="admin-home-card-grp">
          {/* Top 5 liked */}
          <Card>
            <OverallCourseLikedChart />
          </Card>
          <Card>
            <ShowTop10CourseLiked />
          </Card>
        </CardGroup>
        <CardGroup className="admin-home-card-grp">
          {/* Date/Like Chart */}
          <Card>
            <LikeOverTimeChart />
          </Card>
        </CardGroup>
        <CoursesTable />
      </div>
    </Fragment>
  );
};

export default CourseStatistics;
